define('plugin/client-login/ClientLoginPlugin',['require','lib/plugin/PluginAbstract','plugin/client-login/model/ClientSignInModel','plugin/client-login/model/ClientValidateLoginModel','plugin/client-login/step/ClientLoginStep','plugin/client-login/view/ClientLoginInfoView','plugin/client-login/view/ClientLoginLayoutModuleView','plugin/client-login/controller/ClientLoginController','lib/terms/ClientTermsController','lib/WindowMessageListener','lib/AppRouter'],function (require) {

    var PluginAbstract = require('lib/plugin/PluginAbstract');
    var ClientSignInModel = require('plugin/client-login/model/ClientSignInModel');
    var ClientValidateLoginModel = require('plugin/client-login/model/ClientValidateLoginModel');
    var ClientLoginStep = require('plugin/client-login/step/ClientLoginStep');
    var ClientLoginInfoView = require('plugin/client-login/view/ClientLoginInfoView');
    var ClientLoginLayoutModuleView = require('plugin/client-login/view/ClientLoginLayoutModuleView');
    var ClientLoginController = require('plugin/client-login/controller/ClientLoginController');
    var ClientTermsController = require('lib/terms/ClientTermsController');
    var WindowMessageListener = require('lib/WindowMessageListener');
    var AppRouter = require('lib/AppRouter');

    return PluginAbstract.extend({

        _clientModel: null,
        _popupSignInModel: null,
        _signInModel: null,
        _clientValidateLoginModel: null,
        _clientLoginRegions: {
            clientLogin: '#sb_client_login_container'
        },
        _clientLoginModuleRegions: {
            clientLoginForm: '#sb_client_info'
        },
        _controller: null,
        _termsController: null,
        _clientValidateTimeout: 60000,
        _clientModelReady : false,

        /**
         * Initializes plugin
         */
        initialize: function () {
            this.initModel();
            this.initRoutes();
            this.initOpenIdAuth();

            this._termsController = ClientTermsController.getInstance({
                'client': this._clientModel
            });

            this.subscribePopupEvents();
            this.initClientValidateLogin();
        },

        initClientValidateLogin: function () {
            setInterval(_.bind(this._validateClientLogin, this), this._clientValidateTimeout);
        },

        _validateClientLogin: function () {
            if (this._clientModel.get('is_logged_in')) {
                this._clientValidateLoginModel.fetch({
                    skip_loader: true
                });
            }
        },

        _checkClientLogin: function () {
            if (this._clientValidateLoginModel.get('id') != this._clientModel.get('id')) {
                this.fetchClient();
                Backbone.Wreqr.radio.vent.trigger('client_login', 'client:idchanged');
            }
        },

        _onClientLoginStatusChanged : function(){
            var isLogged = this._clientModel.get('is_logged_in');
            if(this._clientModelReady) {
                Backbone.Wreqr.radio.vent.trigger('client_login', isLogged ? 'client:signin' : 'client:signout', {
                    id : isLogged? this._clientModel.get('id') : null,
                });
            }
        },

        getTermsController: function () {
            return this._termsController;
        },

        /**
         * Subscribe to events to show/hide client info popups
         */
        subscribePopupEvents: function () {
            var messagesChannel = Backbone.Wreqr.radio.channel('client_login');

            messagesChannel.vent.on('remindPopup', _.bind(this._controller.remindPopup, this._controller));
            messagesChannel.vent.on('viewProfilePopup', _.bind(this._controller.viewProfilePopup, this._controller));
            messagesChannel.vent.on('editProfilePopup', _.bind(this._controller.editProfilePopup, this._controller));
        },

        /**
         * Listen to messages from open id login window and fetch/update client data
         */
        initOpenIdAuth: function () {
            var listener = new WindowMessageListener();
            this.listenTo(listener, 'message', _.bind(this._handleWindowMessage, this));
        },

        /**
         * Initialize client model
         */
        initModel: function () {
            this._popupSignInModel = new ClientSignInModel();
            this._signInModel = new ClientSignInModel();
            this._clientModel = this.getOption('clientModel');
            this._clientValidateLoginModel = new ClientValidateLoginModel();

            this.listenTo(this._signInModel, 'sync', this.fetchClient);
            this.listenTo(this._popupSignInModel, 'sync', this.fetchClient);
            this.listenTo(this._clientValidateLoginModel, 'sync', this._checkClientLogin);

            //this.fetchClient();
        },

        getClientModel: function () {
            return this._clientModel;
        },

        /**
         * Initialize plugins modules
         */
        initModules: function (layout) {
            _.each(this._clientLoginModuleRegions, function (selector, clientLoginRegion) {
                layout.addRegion(clientLoginRegion, selector);
            });

            var view = new ClientLoginLayoutModuleView({
                clientModel: this._clientModel,
                model: this._popupSignInModel
            });

            this.listenTo(view, 'signIn', _.bind(function (data) {
                this.performSignIn(data.view.getDataToSignIn(), this._popupSignInModel);
            }, this));
            this.listenTo(view, 'signOut', this.performSignOut);

            layout.clientLoginForm.show(view);
        },

        /**
         * Fetches client data from server
         */
        fetchClient: function () {
            this.resetErrors();

            this._clientModel.fetch();
        },

        resetErrors: function () {
            this._clientModel.validationError = null;
            this._signInModel.validationError = null;
            this._popupSignInModel.validationError = null;
        },

        /**
         * Inits client login routes
         */
        initRoutes: function () {
            this._controller = new ClientLoginController({
                app: this.getOption('app'),
                clientModel: this._clientModel,
                signInModel: this._signInModel,
                handler: this
            });

            var clientRouter = new AppRouter({
                appRoutes: {
                    'client/remind-password(/)': 'remind',
                    'client/profile(/:edit)(/)': 'profile',
                    'client/password(/hash/:hash)(/)': 'password',
                    'client/sign-out(/)': 'signOut',
                    'client/sign-in(/back/:back)(/message/:message)(/)': 'signIn'
                },
                menuItem: 'client_login',
                controller: this._controller
            });
        },

        /**
         * Updates client info for booking model
         */
        updateClientInfo: function (model) {
            if(model && !this._clientModelReady){
                this._clientModelReady = true;
                Backbone.Wreqr.radio.vent.trigger('client_login', 'client:ready');
            }
            var bookingModel = this._stepManager.getBookingModel();

            bookingModel.set({
                'client_name': this._clientModel.get('name'),
                'client_phone': this._clientModel.get('phone'),
                'client_email': this._clientModel.get('email'),
                'client_hash': this._clientModel.get('client_hash'),
                'client_id': this._clientModel.get('id')
            });
        },

        /**
         * Subscribe to event to client login information
         */
        initStepManagerEvents: function () {
            this.listenTo(this._stepManager, 'step:render:details', this.addClientLoginView);
            this.listenTo(this._clientModel, 'sync', this.updateClientInfo);
            this.listenTo(this._clientModel, 'change:is_logged_in', this._onClientLoginStatusChanged);
            this.listenTo(this._clientModel, 'perform:signout', this._performSignOut);

            this.updateClientInfo();
        },

        /**
         * Before show details step view we add client login regions and view
         *
         * @param DetailsStep step
         * @param DetailsView view
         * @param Marionette.Region region
         */
        addClientLoginView: function (step, view, region) {
            this._detailsStep = step;
            this._detailsStepView = view;
            _.each(this._clientLoginRegions, function (selector, clientLoginRegion) {
                view.addRegion(clientLoginRegion, selector);
            });

            var infoView = new ClientLoginInfoView({
                model: this._clientModel,
                step: this._detailsStep
            });

            this.listenTo(infoView, 'signOut', this.performSignOut);

            this._detailsStepView.clientLogin.show(infoView);
            this._detailsStepView.ui.clientInfoForm.remove();
        },

        /**
         * Adds client registration/login step before client details.
         * It will show only if user is not logged in.
         *
         * @param Array steps
         * @return Array|null
         */
        modifySteps: function (steps) {
            var index = _.indexOf(steps, 'details');
            steps.splice(index, 0, 'client-login');

            return steps;
        },

        /**
         * Returns plugin step object
         *
         * @see lib/controller/booking/BaseStep
         * @param String step - step name
         * @param Object params - step parameters
         * @return BaseStep|null
         */
        getStep: function (step, params) {
            if (step === 'client-login') {
                return new ClientLoginStep(_.extend({}, params, {
                    clientModel: this._clientModel,
                    signInModel: this._signInModel,
                    handler: this
                }));
            }
        },

        /**
         * On sign in validate login data and try to login on server
         *
         * @param data
         */
        performSignIn: function (data, signinModel) {
            this.resetErrors();

            signinModel = signinModel || this._signInModel;

            signinModel.set(data);
            signinModel.save();
        },

        /**
         * On sign up validate data and try to sign up on server
         *
         * @param data
         */
        performSignUp: function (data) {
            //TODONOW extra fields validation and pass 
            this.resetErrors();

            data.terms = this._termsController.getModel().getAcceptedTerms();
            this._clientModel.set(data);

            var termsValid = this._termsController.validate();
            var clientValid = this._clientModel.isValid();

            if (termsValid && clientValid) {
                this._clientModel.save();
            }
        },

        _performSignOut : function(){
            this.performSignOut();
            this._onClientLoginStatusChanged();
        },

        /**
         * Log out user
         */
        performSignOut: function () {
            this._signInModel.signOut();

            this._signInModel.clear({silent: true});
            this._clientModel.clear({silent: true});
            this._popupSignInModel.clear({silent: true});
        },

        /**
         * Handle open id login message
         *
         * @private
         */
        _handleWindowMessage: function (data) {
            //var data = event.originalEvent.data;
            if (data.open_id_message) {
                if (data.session_id) {
                    //add header to all future requests
                    // console.log('Setting session ID from open id message:', data.session_id, data.csrf_token); //DEBUG
                    jQuery.ajaxSetup({
                        headers: {
                            'x-session-id': data.session_id,
                            'x-csrf-token': data.csrf_token
                        }
                    });
                }

                if (data.client) {
                    this._clientModel.fetch();
                } else {
                    this._clientModel.set({
                        'name': data.user_data.user_name,
                        'email': data.user_data.user_email,
                        'provider': data.provider,
                        'user_id': data.user_data.user_id
                    });

                    var currentUrl = Backbone.history.getFragment();
                    if (currentUrl.indexOf('book/') === 0) {
                        return;
                    }

                    var backUrl = 'client/sign-in';
                    if (currentUrl.length) {
                        backUrl += '/back/' + encodeURIComponent(currentUrl);
                    }
                    backUrl += '/message/open_id';

                    Backbone.history.navigate(backUrl, {
                        'trigger': true
                    });
                }
            }
        }

    });

});
